var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "voice-agent-dashboard" } },
    [
      _c("AppBreadCrumb", {
        attrs: {
          paths: [
            { title: "AI Ses Ajanı", route: "/integrations/voice-agent" },
            { title: _vm.breadcrumbTitle },
          ],
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "voice-agent-dashboard-wrapper" },
        [
          _c("SidebarChild", {
            attrs: {
              items: _vm.VoiceAgentMenuTypes,
              "selected-item": _vm.activeTab,
              focusActive: true,
              defaultOpen: true,
            },
            on: { selected: _vm.selectedTab },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "page-content" },
            [
              _vm.activeTab === "agents"
                ? [
                    _vm.selectedAgentId
                      ? _c("AgentEditor", {
                          attrs: {
                            channelId: _vm.channelId,
                            agentId: _vm.selectedAgentId,
                            activeTab: _vm.agentEditorActiveTab,
                          },
                          on: { back: _vm.clearSelectedAgent },
                        })
                      : _c("AgentList", {
                          attrs: { channelId: _vm.channelId },
                        }),
                  ]
                : _vm.activeTab === "knowledge-base"
                ? _c("KnowledgeBase", { attrs: { channelId: _vm.channelId } })
                : _vm.activeTab === "phone-numbers"
                ? _c("PhoneNumbers", { attrs: { channelId: _vm.channelId } })
                : _vm.activeTab === "batch-call"
                ? _c("BatchCall", { attrs: { channelId: _vm.channelId } })
                : _vm.activeTab === "call-history"
                ? _c("CallHistory", { attrs: { channelId: _vm.channelId } })
                : _vm.activeTab === "automations"
                ? _c("AutomationList", {
                    attrs: { type: "event", module: "voiceagent" },
                  })
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }